// app/utils/constants.ts - 全局常量与错误码映射

export const ERROR_CODES = {
  LOGIN_EXPIRED: 4001002,
  INVALID_TOKEN: 5513002,
  UNSUPPORTED_FORMAT: 5001001,
  INSUFFICIENT_QUOTA: 5002001
} as const

export const ERROR_MESSAGES: Record<number, string> = {
  [ERROR_CODES.LOGIN_EXPIRED]: '登录已过期，请重新登录',
  [ERROR_CODES.INVALID_TOKEN]: '登录状态无效，请重新登录',
  [ERROR_CODES.UNSUPPORTED_FORMAT]: '文件格式不支持',
  [ERROR_CODES.INSUFFICIENT_QUOTA]: '配额不足，无法继续操作'
}

export const HTTP_STATUS_MESSAGES: Record<number, string> = {
  400: '请求参数错误',
  401: '未授权，请先登录',
  403: '无权限访问此资源',
  404: '请求的资源不存在',
  408: '请求超时',
  429: '请求过于频繁，请稍后再试',
  500: '服务器内部错误',
  502: '网关错误',
  503: '服务暂时不可用',
  504: '网关超时'
}
